'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dPolicies$002dPage$0024 from "./presto.-List-Policies-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002479 from "./presto.-Presto-Router$$anon$79.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$78() {
  this.bnt = null;
  this.bnl = null;
  this.bnm = false;
  this.bnu = null;
  this.bnv = false;
  this.bny = null;
  this.bnr = null;
  this.bns = false;
  this.bnn = null;
  this.bno = false;
  this.bnp = null;
  this.bnq = false;
  this.bnw = false;
  this.bnx = false;
  this.bnt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bny = "ListPoliciesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$78 as $c_Lpresto_PrestoRouter$$anon$78 };
$p = $c_Lpresto_PrestoRouter$$anon$78.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$78;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$78() {
}
export { $h_Lpresto_PrestoRouter$$anon$78 as $h_Lpresto_PrestoRouter$$anon$78 };
$h_Lpresto_PrestoRouter$$anon$78.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bnt;
});
$p.L = (function() {
  if ((!this.bnm)) {
    this.bnl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnm = true;
  }
  return this.bnl;
});
$p.O = (function() {
  if ((!this.bnv)) {
    this.bnu = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bnv = true;
  }
  return this.bnu;
});
$p.E = (function() {
  return this.bny;
});
$p.t = (function() {
  if ((!this.bns)) {
    this.bnr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bns = true;
  }
  return this.bnr;
});
$p.M = (function() {
  if ((!this.bno)) {
    this.bnn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bno = true;
  }
  return this.bnn;
});
$p.Q = (function() {
  if ((!this.bnq)) {
    this.bnp = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002479.$c_Lpresto_PrestoRouter$$anon$79();
    this.bnq = true;
  }
  return this.bnp;
});
$p.w = (function() {
  if ((!this.bnx)) {
    this.bnw = false;
    this.bnx = true;
  }
  return this.bnw;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee528) => ((p) => \u03b4scrutinee528))($j_presto$002e$002dList$002dPolicies$002dPage$0024.$m_Lpresto_ListPoliciesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$78 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$78, "presto.PrestoRouter$$anon$78", ({
  OM: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$78 as $d_Lpresto_PrestoRouter$$anon$78 };
//# sourceMappingURL=presto.-Presto-Router$$anon$78.js.map
